export default {"src":"/_next/static/media/VFC.5ace83f2.svg","height":18,"width":18};